import React, { useEffect, useState } from 'react';
import './AccountSettings.css';
import useBlockCheck from '../../hooks/useBlockCheck'; // Import the hook
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../../api';
import UsersTopbar from '../UsersTopbar/UsersTopbar';
import swal from 'sweetalert';
import { useAuth } from '../../context/AuthContext';

const AccountSettings = () => {
  useBlockCheck('user'); // 🔥 Prevents blocked users from accessing this page
  const navigate = useNavigate();
  const { token } = useAuth();
  const [email, setEmail] = useState('');

  // Fetch the user's email
  useEffect(() => {
    const fetchEmail = async () => {
      try {
        const response = await axios.get(api.getProfile, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setEmail(response.data.email);
      } catch (error) {
        console.error('Error fetching email:', error);
        swal('Error', 'Failed to fetch email', 'error');
      }
    };

    fetchEmail();
  }, [token]);

  return (
    <div>
      <UsersTopbar />
      <div className="account-settings-container">
        <button 
          className="account-settings-close-button" 
          onClick={() => navigate('/home')}
          aria-label="Close"
        >
        ×
        </button>
        <h1>Manage Your Account</h1>
        <div className="account-settings-options">
          <div className="settings-content">
            <p>
            Here, you can manage your account settings.
            </p>
            <div className="form-container">
              <div className="account-settings-form">
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <div className="email-display">
                    <h6>Your email address is: </h6>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      readOnly
                      placeholder="Your email"
                    />
                  </div>
                </div>
                <div className="settings-form-button-container">
                  <button
                    type="button"
                    className="settings-form-cancel-button"
                    onClick={() => navigate('/home')}
                  >
                  Back to Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;